// extracted by mini-css-extract-plugin
module.exports = {"infoIcon":"ActiveUserInDaysChart_infoIcon__1KPH4","info":"ActiveUserInDaysChart_info__2IHn6","infoValue":"ActiveUserInDaysChart_infoValue__xTqyj"};